import { isEmpty } from '../../../utils'

export const dateTimeSchemaHandle = {
  handle (node) {
    const {props, _type} = node
    return {
      props: {
        ...props,
        type: _type.toLowerCase()
      }
    }
  }
}

export const dateTimeProps = {
  value: {
    type: String,
    default: '',
    require: true
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // 是否能早于添加数据时的日期
  canBeforeAddData: {
    type: Boolean,
    default: false
  },
  // 未选择时间时的展示文案
  placeholder: {
    type: String,
    default: '选择时间'
  },
  // 输入框尺寸 （large，small，mini）
  size: {
    type: String,
    default: 'small'
  },
  // 显示类型
  type: {
    type: String,
    default: 'datetime'
  },
  // 显示在输入框中的格式
  format: {
    type: String,
    default: 'yyyy-MM-dd HH:mm:ss'
  },
  // 可选，绑定值的格式。不指定则绑定值为 Date 对象
  valueFormat: {
    type: String,
    default: 'yyyy-MM-dd HH:mm:ss'
  },
  // 是否为纯文本
  isPureText: {
    type: Boolean,
    default: true
  },
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}
